import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
// import Reaptcha from 'reaptcha';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FORM_SIGNIN } from '@/modules/Guest';
import {
  email,
  required,
  minLength4,
  unacceptableSigns,
} from '@/utils/Validate';

// Components
import { FormGroup } from 'UIKit/Form';
import { Flex, Box } from 'UIKit/Grid';
import RenderTextField from 'sama_global/components/RenderInput/RenderTextField';
import StyledButton from 'sama_global/components/StyledButton';

const SigninForm = ({
  invalid,
  pristine,
  submitting,
  isLoading,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <FormGroup>
      <Field
        name="email"
        component={RenderTextField}
        type="text"
        label="EMAIL"
        validate={[required, email, unacceptableSigns]}
        normalize={value => value.trim()}
        fullWidth
      />
    </FormGroup>
    <FormGroup>
      <Field
        name="password"
        component={RenderTextField}
        type="password"
        label="PASSWORD"
        autocomplete="new-password"
        validate={[required, minLength4, unacceptableSigns]}
        normalize={value => value.trim()}
        fullWidth
      />
    </FormGroup>
    <Box pb={2} mb={2}>
      <Flex justifyContent="space-between">
        <Box width="100%" mt={4}>
          <StyledButton
            fullWidth
            type="submit"
            disabled={invalid || pristine || submitting}
            variant="contained"
            isLoading={isLoading}
          >
            <FormattedMessage id="signin.btn_title" />
          </StyledButton>
        </Box>
      </Flex>
    </Box>
  </form>
);

SigninForm.propTypes = {
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
};

SigninForm.defaultProps = {
  isLoading: false,
};

export default reduxForm({
  form: FORM_SIGNIN,
})(injectIntl(SigninForm));
